import {ReactComponent as PeopleIcon} from '../../components/svgs/peopleIcon.svg';
import StatusDropdown from '../../components/StatusDropdown';
import CustomerHeader from '../../components/CustomerHeader';
import ManagerCustomerStatusCard from '../../components/manager/ManagerCustomerStatusCard';
import OwnerSidebar from '../../components/owner/OwnerSidebar';
import OwnerCustomerTab from '../../components/owner/OwnerCustomerTab';



// laundry status data
const laundryStatus = [
  { label: 'Active', link: '#' },
  { label: 'Archived', link: '#' },

];

const OwnerCustomerScreen = () => {
  return (
    <>
        <section className='dashboard-container flex '>
          <aside className=''>
              <OwnerSidebar/>
          </aside>
          <main className='main-container mb-32'>
              <CustomerHeader orderTitle={'Customers'} orderSubtitle={'Manage customers'} showCreateOrderScreen={false} showCustomersDropdownButton={true} showCommercialCustomerLink={true}/>

            <section className='mt-10 flex gap-5'>
              <ManagerCustomerStatusCard icon={<PeopleIcon/>} noOfCustomers={221} noOfOrdersClassName={'custom-style'} dueDay={'In Laundry'} customers={'customers'} customerText={'Customers'} activeNumber={92} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All'} className="ml-52"/>}/>
              <ManagerCustomerStatusCard icon={<PeopleIcon/>} noOfCustomers={221} noOfOrdersClassName={'custom-style'} dueDay={'In Laundry'} customers={'customers'} customerText={'Personal Accounts'} activeNumber={92} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All'} className="ml-32" />}/> 

              <ManagerCustomerStatusCard icon={<PeopleIcon/>} noOfCustomers={221} noOfOrdersClassName={'custom-style'} dueDay={'In Laundry'} customers={'customers'} customerText={'Commercial Accounts'} activeNumber={92} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All'} className="ml-24" />}/> 

            </section>
            <section className='mt-20 flex gap-4'>
              <section>
                <OwnerCustomerTab/>
              </section>
            </section> 
          </main>
        </section>
    </>
    
  )
}

export default OwnerCustomerScreen